export default "__VITE_ASSET__DkOWu2el__"